import React, { useEffect } from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import CartDrawer from '../components/cart/CartDrawer';
import { Link } from 'react-router-dom';
import { Truck, Shield, Award, Users, CheckCircle2, Wrench, ArrowRight } from 'lucide-react';
import { siteImages } from '../data/mock';

const WhyChooseUsPage = () => {
  useEffect(() => { document.title = 'Why Choose Us | Tool Supply Point'; }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <CartDrawer />

      <main>
        <section className="relative h-64 md:h-80 overflow-hidden bg-dark-900">
          <img src={siteImages.aboutBanner} alt="Why choose us" className="absolute inset-0 w-full h-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-r from-dark-900 via-dark-900/85 to-dark-900/40" />
          <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center">
            <div>
              <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-athletic-600/15 border border-athletic-600/30 rounded-sm text-athletic-400 text-xs font-bold uppercase tracking-widest mb-4">
                <Wrench className="w-3.5 h-3.5" /> Our Difference
              </div>
              <h1 className="font-display text-4xl md:text-5xl text-white font-bold uppercase mb-3">Why Choose Tool Supply Point?</h1>
              <p className="text-dark-200 max-w-lg">Hand-picked gear, fair prices and a buying experience built around the job.</p>
            </div>
          </div>
        </section>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
            {[
              { icon: Truck, title: 'Fast USA Shipping', desc: 'Free USPS shipping on every order, moving out the door in one business day.' },
              { icon: Shield, title: 'Secure Checkout', desc: 'Your payment details stay locked down with SSL encryption end to end.' },
              { icon: Award, title: 'Tools That Last', desc: 'Every tool earns its spot on the wall before we ever list it for sale.' },
              { icon: Users, title: 'Real Support', desc: 'A crew that knows tools and helps you spec the right one for the task.' },
            ].map((item, i) => (
              <div key={i} className="bg-dark-50 border border-dark-200 rounded-sm p-6 hover:border-athletic-400 transition-all group">
                <div className="w-14 h-14 bg-athletic-600 rounded-sm flex items-center justify-center mb-5 group-hover:shadow-glow-athletic transition-shadow">
                  <item.icon className="w-7 h-7 text-white" />
                </div>
                <h3 className="font-display font-bold uppercase text-dark-900 text-lg mb-2">{item.title}</h3>
                <p className="text-dark-500 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>

          <div className="bg-dark-50 border border-dark-200 rounded-sm p-8 md:p-12 mb-16">
            <div className="text-center mb-10">
              <h2 className="font-display text-3xl font-bold uppercase text-dark-900 mb-4">The Tool Supply Point difference</h2>
              <p className="text-dark-500 max-w-2xl mx-auto">Here is what sets us apart from the big-box tool aisle.</p>
            </div>
            <div className="grid md:grid-cols-2 gap-6">
              {[
                'A carefully hand-picked tool selection',
                'Pro-grade quality at fair prices',
                '30-day hassle-free returns',
                'Fast processing and shipping',
                'Secure payment processing',
                'Clear, honest specs and descriptions',
                'Responsive customer support',
                'A clean, easy-to-use website',
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-3 p-4 bg-white rounded-sm border border-dark-200">
                  <CheckCircle2 className="w-5 h-5 text-athletic-600 flex-shrink-0" />
                  <span className="text-dark-900 font-medium">{item}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="text-center bg-gradient-athletic rounded-sm p-12">
            <h2 className="font-display text-3xl font-bold uppercase text-white mb-4">Ready to gear up?</h2>
            <p className="text-white/90 mb-8 max-w-xl mx-auto">Browse our hand-picked collection of hardware and power tools and feel the Tool Supply Point difference.</p>
            <Link to="/shop" className="inline-flex items-center gap-2 px-8 py-4 bg-dark-900 text-white font-bold uppercase tracking-wider rounded-sm hover:bg-dark-800 transition-all">
              Shop Now <ArrowRight className="w-5 h-5" />
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default WhyChooseUsPage;
